module.exports = __webpack_public_path__ + "static/img/menu_close_wh.abdf1e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/menu_close_wh.png
// module id = Ztfx
// module chunks = 10